import { RECEIVE_INTERLINE_OPERATORS } from "../actions/interlineOperatorsActions";

const initialState = {};

export default function interlineOperatorsReducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_INTERLINE_OPERATORS:
      return {
        ...state,
        operators: [...action.payload]
      };
    default:
      return state
  }
};



// WEBPACK FOOTER //
// ./src/reducers/interlineOperatorsReducer.js